
<d-contract-edit
    v-model      = "edit"
    title        = "Notruf"
    :type-id     = "typeId"
    :contract-id = "contractId"
    :company-id  = "companyId"
    @initialized = "onInitialized"
    @saved       = "onSaved"
>
    <!--
    <template slot="terms">
        <c-column-header
            class  = "primary mt-0"
            :label = "$t('contract.terms')"
        />

        <div class="lm-border pa-3 pt-0 mt-1">
            <c-contract-esc-terms
                :contract   = "contract"
                :readonly   = "false"
                :show-title = "false"
                class       = "mt-2"
                style       = "height: 686px;"
            />
        </div>
    </template>
    -->
</d-contract-edit>
